<template>
  <div class="home">
    <ForgotPassword />
  </div>
</template>

<script>
import ForgotPassword from "@/components/auth/ForgotPassword.vue";

export default {
  name: "ForgotPasswordView",
  components: {
    ForgotPassword
  }
};
</script>
